<template>
  <div class="price-histogram-slider">
    <div class="slider-wrapper">
      <!-- 1) Statická linka (track) -->
      <div class="track"></div>

      <!-- 2) Histogram bars -->
      <div class="bars">
        <div
            v-for="bar in completeBars"
            :key="bar.rangeFrom"
            class="bar"
            :style="barStyle(bar)"
        ></div>
      </div>

      <!-- 3) Zvýrazněný úsek mezi thumby -->
      <div class="selected-track" :style="selectedTrackStyle"></div>

      <!-- 4) Thumby -->
      <input
          class="thumb thumb--lower"
          type="range"
          :min="min"
          :max="max"
          :step="step"
          v-model.number="local[0]"
          @input="updateRange('lower')"
          @change="onChange"
      />
      <input
          class="thumb thumb--upper"
          type="range"
          :min="min"
          :max="max"
          :step="step"
          v-model.number="local[1]"
          @input="updateRange('upper')"
          @change="onChange"
      />
    </div>

    <!-- 5) Popisky pod sliderem -->
    <div class="labels">
      <div class="thumb-label">{{ formatMoney(local[0]) }}</div>
      <div class="thumb-label">{{ formatMoney(local[1]) }}</div>
    </div>
  </div>
</template>

<script setup>
import { usePriceHistogramSlider } from '@/composables/usePriceHistogramSlider'

const props = defineProps({
  modelValue: { type: Array,  required: true }, // [from, to]
  min:        { type: Number, required: true },
  max:        { type: Number, required: true },
  bars:       { type: Array,  required: true }, // [{ rangeFrom, rangeTo, count }]
  step:       { type: Number, required: true },  // musíš předat z rodiče!
})
const emit = defineEmits(['update:modelValue'])

// Use the composable for shared logic
const {
  local,
  updateRange,
  onChange,
  barStyle: baseBarStyle,
  selectedTrackStyle,
  formatMoney,
  completeBars
} = usePriceHistogramSlider(props, emit)

// --- 6) Styl každého bar s výchozími barvami
function barStyle(bar) {
  return baseBarStyle(bar, '#3b5998', '#e0e0e0')
}
</script>

<style scoped>
.price-histogram-slider { width: 100%; }
.slider-wrapper { position: relative; height: calc(100px + 12px); }
.track {
  position: absolute; top:100px; left:0;
  width:100%; height:4px;
  background:#3b5998; border-radius:2px; z-index:1;
}
.bars {
  position:absolute; top:0; left:0; right:0;
  height:100px; z-index:2;
  overflow: hidden;
}
.bar {
  position:absolute; bottom:0;
  border-radius:2px;
}
.selected-track {
  position:absolute; top:100px; height:4px;
  background:#3b5998; border-radius:2px; z-index:2;
}
.thumb {
  -webkit-appearance:none; position:absolute;
  top:94px; left:0; width:100%;
  background:transparent; pointer-events:none;
  /* Firefox-specific fixes */
  -moz-appearance: none;
}
/* Firefox-specific positioning */
@-moz-document url-prefix() {
  .thumb {
    top: 92px;
  }
}
.thumb::-webkit-slider-thumb {
  -webkit-appearance:none; pointer-events:auto;
  width:16px; height:16px;
  background:#fff; border:2px solid #3b5998;
  border-radius:50%; cursor:pointer;
}
.thumb::-moz-range-thumb {
  width:16px; height:16px;
  background:#fff; border:2px solid #3b5998;
  border-radius:50%; cursor:pointer;
  pointer-events:auto;
  /* Firefox-specific fixes */
  -moz-appearance: none;
  box-sizing: border-box;
}
.thumb::-moz-range-track {
  background: transparent;
  border: none;
  height: 4px;
  -moz-appearance: none;
}
.thumb::-moz-focus-outer {
  border: 0;
}
.thumb--lower { z-index:3; }
.thumb--upper { z-index:4; }
.labels {
  display:flex; justify-content:space-between;
  margin-top:0.5rem;
  margin-bottom:1.5rem;
  width: 100%;
  pointer-events: none;
}
.thumb-label {
  background: var(--bs-primary);
  color: #fff;
  padding: 4px 8px;
  font-size: 0.75rem;
  border-radius: 0.5rem;
  white-space: nowrap;
  min-width: 30px;
  text-align: center;
  z-index: 6;
}
</style>
